import React from 'react';
import styled from 'styled-components';
import { BORDER_RADIUS } from '../../constants';

const InputClickable = styled.input`
  &:hover {
    cursor: pointer;
  }
`;

export const Checkbox = (props: React.PropsWithChildren<any>) => <InputClickable type="checkbox" {...props} />;

const Input = styled.input`
  border: .1rem solid #ccc;
  border-radius: ${BORDER_RADIUS};
  display: block;
  box-sizing: border-box;
  letter-spacing: .05rem;
  margin-top: 0.2rem;
  padding: .3rem .5rem;
  width: 100%;
`;

export const InputMandatory = styled(Input)`
  border-left: .15rem solid #c42020;
`;

const InputGroupStyle = styled.div`
  margin-bottom: 1rem;
`;
export const InputGroup = (props: React.PropsWithChildren<any>) => <InputGroupStyle>{props.children}</InputGroupStyle>;

export default Input;
